export default "__VITE_ASSET__28556087__"